export interface NegativeOption {
  id: number;
  text: string;
  option_type: number;
}

export interface FeedbackOption {
  text_key: string;
  text_value: FeedbackResult.Yes | FeedbackResult.No;
  button_id: string;
  button_type: string;
}

export enum FeedbackResult {
  Empty,
  Yes,
  No
}
